export const PHONE_REGEXP_VALIDATION = /^\+\d{1,4}\s?\d{8,11}$/;
